import { render, staticRenderFns } from "./NewInvitation.vue?vue&type=template&id=0094c442&scoped=true&lang=html&"
import script from "./NewInvitation.vue?vue&type=script&lang=js&"
export * from "./NewInvitation.vue?vue&type=script&lang=js&"
import style0 from "./NewInvitation.vue?vue&type=style&index=0&id=0094c442&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0094c442",
  null
  
)

export default component.exports